let popupList = [
  {
    id: 1,
    src: "https://i.ibb.co/PNShrgW/resize-16860612351044159846bicycle.jpg",
  },
  {
    id: 2,
    src: "https://i.ibb.co/VSr10NL/resize-1686061565642467046motorcycle.jpg",
  },
  {
    id: 3,
    src: "https://i.ibb.co/hZtXsTv/resize-1686061173903315482auto-Ricksaw.png",
  },
  {
    id: 4,
    src: "https://i.ibb.co/WDZR70x/resize-16860615971008626215smallcar.jpg",
  },
  {
    id: 5,
    src: "https://i.ibb.co/vzSfxhB/resize-16860625721921803598sedan1removebgpreview.jpg",
  },
  {
    id: 6,
    src: "https://i.ibb.co/vzSfxhB/resize-16860625721921803598sedan1removebgpreview.jpg",
  },
  {
    id: 7,
    src: "https://i.ibb.co/vzSfxhB/resize-16860625721921803598sedan1removebgpreview.jpg",
  },
  {
    id: 8,
    src: "https://i.ibb.co/4g4bf2N/resize-1686062818584473524busremovebgpreview.jpg",
  },
  {
    id: 9,
    src: "https://i.ibb.co/4g4bf2N/resize-1686062818584473524busremovebgpreview.jpg",
  },
  {
    id: 10,
    src: "https://i.ibb.co/4g4bf2N/resize-1686062818584473524busremovebgpreview.jpg",
  },
];
export default popupList;
